export var getTagName = function getTagName(props) {
  var tag = props.tag,
      paragraph = props.paragraph,
      pageTitle = props.pageTitle,
      subSectionTitle = props.subSectionTitle,
      sectionTitle = props.sectionTitle;

  if (tag) {
    return tag;
  }

  if (paragraph) {
    return 'p';
  }

  if (pageTitle) {
    return 'h1';
  }

  if (subSectionTitle) {
    return 'h2';
  }

  if (sectionTitle) {
    return 'h3';
  }

  return 'div';
};